import React from 'react';
import styled from '@emotion/styled';
import { graphql, navigate } from 'gatsby';
import { Row } from 'react-flexgrid';

import Layout from '../components/Layout';
import SEO from '../components/Seo';
import BlogCard from '../components/BlogCard';

const Nav = styled.div`
  display: flex;
`;

class BlogIndex extends React.Component {

  static navigateTo(slug) {
    navigate(slug);
  }

  render() {
    const { data } = this.props;
    const siteTitle = data.site.siteMetadata.title;
    const posts = data.allMarkdownRemark.edges;

    return (
      <Layout includeHeader title={siteTitle} didClickContact={this.toggleContactModal}>
        <SEO
          title="Home"
          keywords={[`blog`, `gatsby`, `javascript`, `react`, 'Alex Catchpole', 'alexcatch']}
        />
          <Row>
            {posts.map(({ node }) => {
              const title = node.frontmatter.title || node.fields.slug;
              return (
                <BlogCard
                  onClick={() => BlogIndex.navigateTo(node.fields.slug)}
                  section={node.frontmatter.section}
                  key={node.fields.slug}
                  title={title}
                  excerpt={node.excerpt}
                  dateTime={node.frontmatter.date}
                />
              );
            })}
          </Row>
      </Layout>
    );
  }
}

export default BlogIndex;

export const pageQuery = graphql`
 query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }, filter: { frontmatter: { draft: { eq: false } } }) {
      edges {
        node {
          excerpt(pruneLength: 95)
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            section,
          }
        }
      }
    }
  }
`;
